<svg
  xmlns="http://www.w3.org/2000/svg"
  id="svg-source"
  version="1.1"
  style="position: fixed; width: 0; height: 0"
>
  <style>
    use {
      fill-opacity: 1;
      fill: currentColor;
    }
  </style>

  <symbol id="error-icon" viewBox="0 0 16 16">
    <g
      id="icon/Message/Alert16"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
      <g id="iconAlert">
        <circle id="Background" fill="#E80E51" cx="8" cy="8" r="8"></circle>
        <rect
          id="Stroke"
          fill="#FFFFFF"
          x="7"
          y="3"
          width="2"
          height="6"
        ></rect>
        <polygon id="Dot" fill="#FFFFFF" points="7 11 9 11 9 13 7 13"></polygon>
      </g>
    </g>
  </symbol>
</svg>

<p *ngIf="!!errorMessage && dirty && invalid" class="error-message">
  <i2g-icon class="error-icon" [icon]="errorIcon"> </i2g-icon>

  {{ errorMessage }}
</p>
